let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7Pg2p")).then(() => parcelRequire('qmn3S'));